import { getDefaultClient, hasExtension } from '@dynamic-labs-sdk/client';
import { registerExtension } from '@dynamic-labs-sdk/client/core';

import { registerEvmNetworkProviderBuilder } from '../../registerEvmNetworkProviderBuilder';
import { recoverEvmWalletConnectWalletProviders } from '../recoverEvmWalletConnectWalletProviders';

export const WALLET_CONNECT_EVM_EXTENSION_KEY = 'walletConnectEvm';

/** @not-instrumented */
export const addWalletConnectEvmExtension = async (
  client = getDefaultClient()
) => {
  if (
    hasExtension({ extensionKey: WALLET_CONNECT_EVM_EXTENSION_KEY }, client)
  ) {
    return;
  }

  registerExtension({ extensionKey: WALLET_CONNECT_EVM_EXTENSION_KEY }, client);
  registerEvmNetworkProviderBuilder(client);

  await recoverEvmWalletConnectWalletProviders(client);
};
